var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00016 15.0234H15.0002V6.8213L10.0002 2.27585L5.00016 6.8213V15.0234ZM15.8335 16.6901H4.16683C3.7066 16.6901 3.3335 16.317 3.3335 15.8567V8.35675H0.833496L9.43958 0.533012C9.75741 0.244062 10.2429 0.244062 10.5607 0.533012L19.1668 8.35675H16.6668V15.8567C16.6668 16.317 16.2937 16.6901 15.8335 16.6901ZM6.66683 7.52341C9.8885 7.52341 12.5002 10.1351 12.5002 13.3567H10.8335C10.8335 11.0556 8.968 9.19008 6.66683 9.19008V7.52341ZM6.66683 10.8567C8.04754 10.8567 9.16683 11.976 9.16683 13.3567H6.66683V10.8567Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/Home_Icon.b9624b9bcfc1b991dd3ac95f5634b5f6.svg";
export { ForwardRef as ReactComponent };